<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/jyzn">就医指南</router-link> >
      <router-link to="/jyzn/fenbu">楼层分布</router-link> >
      {{ current.title }}
    </div>

    <div class="container-width">
      <ARTICLE
        :current="current"
        :before="before"
        :after="after"
        :showBeforeAfter="showBeforeAfter"
        :showorigin="showorigin"
        @changePage="handleChangePage"
      ></ARTICLE>
    </div>
  </div>
</template>
<script>
import service from "../../service/jyzn";
import BANNER from "../../components/banner/jyzn";
export default {
  name: "FENBUARTICLE",
  data() {
    return {
      navigationData: [
        {
          name: "就医须知",
          path: "/jyzn",
        },
        {
          name: "门诊就诊流程图",
          path: "/jyzn/liucheng",
        },
        {
          name: "楼层分布",
          path: "/jyzn/fenbu",
        },
        {
          name: "乘车路线",
          path: "/jyzn/luxian",
        },
        {
          name: "联系我们",
          path: "/jyzn/lianxi",
        },
      ],
      currentPath: "/jyzn/fenbu",
      current: {
        title: "",
        description: "",
        releaseDate: "",
        views: "",
        origin: "",
      },
      // 上一篇
      before: {
        title: "",
        id: "",
        active: false,
      },
      // 下一篇
      after: {
        title: "",
        id: "",
        active: false,
      },
      showBeforeAfter: false, //是否显示上一篇 下一篇
      showorigin: false, //是否显示来源 发布时间 点击次数
      showContent: false, // 文章加载后 显示
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {
        id: this.$route.params.id,
      };
      service.getFloorInfo(parmes, (res) => {
        this.current = res || "";        
        this.current.title = this.current.location;
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>


<style scoped lang="scss">
</style>
